/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Position_Modal_TitleInputs */



/**
* | output |
* | --- |
* | "Set Position" |
*
* @param {Position_Modal_TitleInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const position_modal_title = /** @type {((inputs?: Position_Modal_TitleInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Position_Modal_TitleInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Definir la position")
	if (locale === "de") return /** @type {LocalizedString} */ ("Position einstellen")
	if (locale === "it") return /** @type {LocalizedString} */ ("Imposta posizione")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Установить позицию")
	if (locale === "es") return /** @type {LocalizedString} */ ("Establecer posición")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("设置位置")
	if (locale === "ja") return /** @type {LocalizedString} */ ("位置を設定する")
	if (locale === "hi") return /** @type {LocalizedString} */ ("स्थिति निर्धारित करें")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Posição definida")
	return /** @type {LocalizedString} */ ("Set Position")
});